import { IIconProps } from '@fluentui/react';
import { ErrorType } from '../../../models/HttpError';
import { Service } from '../../../models/Entities/Service';

// stores
import * as ServiceStore from '../../../redux/middleware/ServiceMiddleware';

// State
import { AppState } from '../../../redux/reducers';

//#region Icons
export const AddIcon: IIconProps = { iconName: 'CirclePlus' };
export const EditIcon: IIconProps = { iconName: 'Edit' };
export const DeleteIcon: IIconProps = { iconName: 'Delete' };
export const RefreshIcon: IIconProps = { iconName: 'Refresh' };

//#region Types
interface IProps {
  onEdit?: (service: Service) => void;
  searchCriteria?: string;
}

interface ConnectedProps {
  services: Service[];
  isLoadingAll: boolean;
  successLoadingAll: boolean | undefined;
  failOnLoadingAll: boolean;
  isDeleting: boolean;
  isDeletingSuccess: boolean | undefined;
  failOnDeleting: boolean;
  error: ErrorType | undefined;
}

interface ServiceDispatchProps {
  GetAllServices: typeof ServiceStore.actionCreators.GetAllServices;
  DeleteService: typeof ServiceStore.actionCreators.DeleteService;
}

export type Props = IProps & ConnectedProps & ServiceDispatchProps;

//#region Redux mapping
export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  services: state.Services?.list || [],
  isLoadingAll: state.Services?.isLoadingAll || false,
  successLoadingAll: state.Services?.successLoadingAll,
  failOnLoadingAll: state.Services?.failOnLoadingAll || false,
  isDeleting: state.Services?.isDeleting || false,
  isDeletingSuccess: state.Services?.isDeletingSuccess,
  failOnDeleting: state.Services?.failOnDeleting || false,
  error: state.Services?.error
});

export const mapDispatchToProps = {
  ...ServiceStore.actionCreators
};

//#region Helper Functions
export const filterServices = (
  services: Service[],
  searchCriteria?: string
): Service[] => {
  if (!searchCriteria) return services;

  const searchLower = searchCriteria.toLowerCase();
  return services.filter(
    (service) =>
      service.description?.toLowerCase().includes(searchLower) ||
      service.consumerName?.toLowerCase().includes(searchLower) ||
      service.serviceCategoryDescription?.toLowerCase().includes(searchLower) ||
      service.visitName?.toLowerCase().includes(searchLower) ||
      service.serviceStatusName?.toLowerCase().includes(searchLower) ||
      service.id?.toLowerCase().includes(searchLower)
  );
};
